<app-modal-shell [config]="modalConfig">
  <div modal-content class="vae-more-filters-dialog" [formGroup]="form">
    <section class="vae-more-filters-dialog__group">
      <h3>Detalles de la visita</h3>
      <app-data-table-multi-select-filter formControlName="location" label="Lugar" [options]="data.locationOptions"></app-data-table-multi-select-filter>
      <app-data-table-multi-select-filter formControlName="communion" label="Santa Cena" [options]="data.communionOptions"></app-data-table-multi-select-filter>
    </section>

    <section *ngIf="data.showCommunityFilters" class="vae-more-filters-dialog__group">
      <h3>Ubicación</h3>
      <app-data-table-multi-select-filter formControlName="community" label="Comunidad" [options]="data.communityOptions"></app-data-table-multi-select-filter>
      <app-data-table-multi-select-filter formControlName="district" label="Distrito" [options]="data.districtOptions"></app-data-table-multi-select-filter>
      <app-data-table-multi-select-filter formControlName="area" label="Área Apóstol" [options]="data.areaOptions"></app-data-table-multi-select-filter>
    </section>
  </div>

  <ng-container modal-actions>
    <button mat-button type="button" (click)="clearFilters()"><mat-icon>filter_alt_off</mat-icon>Limpiar filtros</button>
    <button mat-button type="button" (click)="cancel()">Cancelar</button>
    <button mat-flat-button color="primary" type="button" (click)="apply()">Aplicar filtros</button>
  </ng-container>
</app-modal-shell>
